import React from 'react';

export default function Download(props) {
  return (
    <svg width={10} height={10} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4.603 9.861c-.12-.087-2.793-2.396-4.5-4.965a.69.69 0 0 1-.035-.66.66.66 0 0 1 .569-.347h2.242c.224-1.406.62-2.934.845-3.316C3.93.208 4.362 0 5 0s1.07.208 1.276.573c.19.33.604 1.91.845 3.316h2.242a.66.66 0 0 1 .57.347.69.69 0 0 1-.035.66c-1.725 2.57-4.38 4.878-4.501 4.965A.688.688 0 0 1 5 10a.688.688 0 0 1-.397-.139z"
        fill="#1FB6FF"
        fillRule="evenodd"
      />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/icons/DownloadBlue/index.js